// Bezahl- und Versandarten als anklickbare Karten mit Logos - die nackten
// Radioknoepfe sagen nicht, was sich hinter "Kreditkarte, Klarna oder
// Google Pay" verbirgt.

const zahlZeilen = document.querySelectorAll(
    '.paymentmethod .radio_container > span, .shippingmethod .radio_container > span, .address .radio_container > span'
);

if (zahlZeilen.length) {
    const logo = (datei, titel) =>
        '<img src="/files/themes/fake-natty/images/icons/' + datei + '" alt="' + titel + '" height="20">';

    const stand = () => {
        zahlZeilen.forEach((zeile) => {
            const feld = zeile.querySelector('input[type="radio"]');
            zeile.classList.toggle('ist-gewaehlt', !!(feld && feld.checked));
        });
    };

    zahlZeilen.forEach((zeile) => {
        const feld = zeile.querySelector('input[type="radio"]');

        if (!feld) {
            return;
        }

        const text = (zeile.querySelector('label') || zeile).textContent.toLowerCase();
        const teile = [];

        if (/paypal/.test(text)) {
            teile.push(logo('paypal.svg', 'PayPal'));
        }

        if (/kredit|karte|stripe|visa/.test(text)) {
            teile.push(logo('visa.png', 'Visa'));
            teile.push(logo('mastercard.png', 'Mastercard'));
        }

        if (/klarna/.test(text)) {
            teile.push('<span class="pay-badge">Klarna</span>');
        }

        if (/google/.test(text)) {
            teile.push('<span class="pay-badge">Google&nbsp;Pay</span>');
        }

        if (teile.length) {
            const kasten = document.createElement('span');
            kasten.className = 'fn-zahl-logos';
            kasten.innerHTML = teile.join('');
            zeile.appendChild(kasten);
        }

        zeile.addEventListener('click', (ereignis) => {
            if (ereignis.target !== feld) {
                feld.checked = true;
            }

            stand();
        });

        feld.addEventListener('change', stand);
    });

    stand();
}


// Auf dem Handy steht die Bestelluebersicht zugeklappt: die Summe sieht man
// in der Kopfzeile trotzdem, und das Formular beginnt oberhalb der Falz.
// Auf breiten Schirmen bleibt sie offen, da ist Platz genug.
const kassenUebersicht = document.querySelector('.fn-kassen-uebersicht');

if (kassenUebersicht && window.matchMedia('(max-width: 767px)').matches) {
    kassenUebersicht.open = false;
}


// Isotope sperrt den Weiter-Knopf nach dem ersten Klick, damit niemand
// doppelt bestellt. Der Aufruf stand vorher als <script> im Template.
if (window.Isotope && typeof window.Isotope.checkoutButton === 'function') {
    document.querySelectorAll('.mod_iso_checkout form').forEach((formular) => {
        window.Isotope.checkoutButton(formular);
    });
}


// Adressfelder: Isotope gibt sie ohne autocomplete aus. Auf dem Handy heisst
// das keine Adressuebernahme, sieben Felder von Hand tippen - und fuer die
// Postleitzahl oeffnet sich nicht einmal die Zahlentastatur. Getrennt nach
// Rechnungs- und Lieferadresse, wie es die HTML-Spezifikation vorsieht.
// (Stand vorher als Regex-Ersetzung in mod_iso_checkout.html5.)
const adressFelder = {
    salutation: 'honorific-prefix',
    firstname: 'given-name',
    lastname: 'family-name',
    company: 'organization',
    street_1: 'address-line1',
    street_2: 'address-line2',
    street_3: 'address-line3',
    postal: 'postal-code',
    city: 'address-level2',
    subdivision: 'address-level1',
    country: 'country',
    phone: 'tel',
    email: 'email'
};

document.querySelectorAll('[id^="ctrl_billingaddress_"], [id^="ctrl_shippingaddress_"]').forEach((feld) => {
    const treffer = feld.id.match(/^ctrl_(billingaddress|shippingaddress)_([a-z0-9_]+)$/i);

    if (!treffer || !adressFelder[treffer[2]] || feld.hasAttribute('autocomplete')) {
        return;
    }

    const bereich = treffer[1] === 'shippingaddress' ? 'shipping ' : 'billing ';
    feld.setAttribute('autocomplete', bereich + adressFelder[treffer[2]]);

    if (treffer[2] === 'postal' && !feld.hasAttribute('inputmode')) {
        feld.setAttribute('inputmode', 'numeric');
    }
});
